function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useContext } from 'react';
import { connect } from 'react-redux';
import { cmsActions } from '../../../reducers/cms.reducer';
import ArticlesEditData from './ArticlesEditData.context';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Label from '../../common/form/Label.react';
import Input from '../../common/form/Input.react';
import Checkbox from '../../common/form/Checkbox.react';
import Button from '../../common/Button.react';
import InputCalendar from '../../common/form/InputCalendar.react';

// TODO :: rename to articleDetails
var ArticlesAddDefault = function ArticlesAddDefault(_ref) {
  var articlesAction = _ref.articlesAction;
  var _useContext = useContext(ArticlesEditData),
    _useContext2 = _slicedToArray(_useContext, 2),
    state = _useContext2[0],
    setState = _useContext2[1];
  var article = state.article,
    articleID = state.articleID,
    articleType = state.articleType,
    title = state.title,
    subtitle = state.subtitle,
    breadcrumbs = state.breadcrumbs,
    breadcrumbsAsTitle = state.breadcrumbsAsTitle,
    newsDate = state.newsDate,
    showProductBuyLink = state.showProductBuyLink,
    archived = state.archived;
  var isValid = function isValid() {
    return title.length > 0 && (article === null || article === void 0 ? void 0 : article.title) !== title || (article === null || article === void 0 ? void 0 : article.subtitle) !== subtitle || (article === null || article === void 0 ? void 0 : article.breadcrumbs) !== breadcrumbs || (article === null || article === void 0 ? void 0 : article.newsDate) !== newsDate || (article === null || article === void 0 ? void 0 : article.showProductBuyLink) !== showProductBuyLink;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Article Details"
  }), /*#__PURE__*/React.createElement(CardBody, null, articleType !== 'faq' && articleType !== 'product' && articleType !== 'video' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    label: "Breadcrumbs / ".concat(breadcrumbs || ''),
    className: "a-details__breadcrumbs"
  }), /*#__PURE__*/React.createElement(Input, {
    value: breadcrumbs,
    onChange: function onChange(e) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        breadcrumbs: e.target.value,
        breadcrumbsAsTitle: e.target.value === title
      }));
    },
    permission: "edit-pos-articles"
  }), /*#__PURE__*/React.createElement(Checkbox, {
    checked: breadcrumbsAsTitle,
    label: "Use Title",
    onChange: function onChange(val) {
      if (breadcrumbsAsTitle) return;
      if (!breadcrumbsAsTitle && val) setState(_objectSpread(_objectSpread({}, state), {}, {
        breadcrumbs: title,
        breadcrumbsAsTitle: true
      }));
    },
    permission: "edit-pos-articles"
  })), /*#__PURE__*/React.createElement(Label, {
    label: "Title",
    required: true,
    className: "a-details__title"
  }), /*#__PURE__*/React.createElement(Input, {
    value: title,
    onChange: function onChange(e) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        title: e.target.value,
        breadcrumbs: breadcrumbsAsTitle ? e.target.value : breadcrumbs
      }));
    },
    permission: "edit-pos-articles"
  }), articleType !== 'faq' && articleType !== 'career' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    label: "Subtitle",
    className: "a-details__subtitle"
  }), /*#__PURE__*/React.createElement(Input, {
    value: subtitle,
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        subtitle: e.target.value
      }));
    },
    permission: "edit-pos-articles"
  })), articleType === 'product' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    label: "Show Product Buy Link"
  }), /*#__PURE__*/React.createElement(Checkbox, {
    checked: showProductBuyLink,
    label: showProductBuyLink ? 'Yes' : 'No',
    onChange: function onChange(showProductBuyLink) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        showProductBuyLink: showProductBuyLink
      }));
    },
    permission: "edit-pos-articles"
  })), articleType === 'news' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    label: "News Date"
  }), /*#__PURE__*/React.createElement(InputCalendar, {
    value: newsDate,
    onChange: function onChange(newsDate) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        newsDate: newsDate
      }));
    },
    permission: "edit-pos-articles"
  })), !archived && /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Save",
    disabled: !isValid(),
    onClick: function onClick() {
      articlesAction({
        formData: {
          articleID: articleID,
          title: title,
          subtitle: subtitle,
          breadcrumbs: breadcrumbs,
          newsDate: newsDate,
          showProductBuyLink: showProductBuyLink
        },
        route: 'details',
        method: 'put'
      });
    },
    permission: "edit-pos-articles"
  })))));
};
var mdtp = {
  articlesAction: cmsActions.articles
};
export default connect(null, mdtp)(ArticlesAddDefault);